import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { birthdayClients } from 'src/app/models/birthdays_clients';

@Component({
  selector: 'app-list-client',
  templateUrl: './list-client.component.html',
  styleUrls: ['./list-client.component.scss'],
})
export class ListClientComponent implements OnInit {
  @ViewChild('modalClient', { static: false }) modalClient!: TemplateRef<any>;
  @ViewChild('modalClientPackages', { static: false })
  modalClientPackages!: TemplateRef<any>;
  @ViewChild('birthdayClients', { static: false }) birthdayClients!: TemplateRef<any>;

  // Dates filters
  selectedFilter: string = '';
  selectedPerMonth: string = '';
  selectedDay: NgbDateStruct | null = null;
  weekStartDate: NgbDateStruct | null = null;
  weekEndDate: NgbDateStruct | null = null;

  modalClientClose: any;
  filterText: string = '';
  clients: any = [];
  filterClients: any = [];
  breadcrumbs: any = [];
  birthdaysData: birthdayClients[] = [];
  birthdaysDataFilter: birthdayClients[] = [];
  page: number = 1;
  // cambios felipe
  limit: number =25;
  totalItems: number = 0;
  rolename: any = '';
  rolekey: any = '';
  idClient: number = 0;
  clientNameDeleted: string = '';
  flagDeleted: boolean = false;
  message: string = '';
  currentOfficeId: number = 0;
  roleofficeid: number = 0;
  offices: any = [];
  filterPackages: any = [];
  flagDeletePackage: boolean = false;
  flagOpenDeletePackage: boolean = false;
  flagDeletedP: boolean = false;
  packageId: number = 0;
  nextLabel = 'Siguiente';
  previousLabel = 'Anterior';
  totalPages: number = 0;
  pages: number[] = [];
  flagMonth: boolean = false;
  flagDay: boolean = false;
  flagPerMonth: boolean = false;

  constructor(
    private api: ApiService,
    private modal: NgbModal,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {

    this.breadcrumbs = [
      {
        name: 'Agenda',
        path: '/dashboard/new-calendar',
        link: true,
      },
      {
        name: 'Lista de clientes',
        link: false,
      },
    ];

    const savedPage = this.route.snapshot.queryParamMap.get('page');

    this.page = savedPage ? +savedPage : 1;

    this.getClients(this.page);

    this.roleInfo();
    this.getOffices();
  }

  reloadInfo() {
    this.getClients();
    this.roleInfo();
    this.getOffices();
  }

  roleInfo() {
    this.api.get('employees/roles').subscribe({
      next: (roles) => {
        this.rolename = roles.user.role;
        this.rolekey = roles.user.key.toLowerCase();
        this.roleofficeid = roles.user.office.id;
        this.currentOfficeId = this.roleofficeid;
      },
      error: (err) => {},
    });
  }

  getClients(page: number = 1): void {

    this.page = page;

    this.api.get(
      `clients?clientId=${this.currentOfficeId}&page=${page}&limit=${this.limit}`
      //`v1/clients?clientId=${this.currentOfficeId}&page=${page}&limit=${this.limit}`
    ).subscribe({
      next: (res) => {

        this.clients = res.clients;
        this.filterClients = this.clients;

        this.totalItems = res.total;
        this.totalPages = res.total_pages;
      }
    });
  }

  getOffices() {
    this.api.get('offices').subscribe({
      next: (offices) => {
        this.offices = offices.offices;
      },
      error: (err) => {},
    });
  }

  setCurrentOffice(evt: any) {
    this.api.get(`clients/${evt.target.value}`).subscribe({
      next: (clients) => {
        this.clients = clients.clients;
        this.filterClients = this.clients;
      },
      error: (err) => {},
    });
  }

  deleteClients(id: number): void {
    this.api.delete('clients', id).subscribe({
      next: (data) => {
        this.message = data.message;
        const id = data.client.id;
        this.flagDeleted = true;

        this.filterClients = this.filterClients.filter(
          (clientData: any) => clientData.id !== id
        );

        this.modalClientClose.close();
      },
      error: (err) => {},
    });
  }

  openDeleteClient(
    id: number,
    clientFirstName: string,
    clientLastName: string
  ): void {
    this.idClient = id;
    this.clientNameDeleted = `${clientFirstName} ${clientLastName}`;

    this.modalClientClose = this.modal.open(this.modalClient, { size: 'md' });
  }

  openListPackages(
    id: number,
    clientFirstName: string,
    clientLastName: string
  ): void {
    this.idClient = id;
    this.clientNameDeleted = `${clientFirstName} ${clientLastName}`;
    this.filterPackages = this.filterClients.filter(
      (data: any) => data.id == this.idClient
    );

    this.modalClientClose = this.modal.open(this.modalClientPackages, {
      size: 'xl',
    });
  }

  close(): void {
    this.modalClientClose.close();
  }

  clearSearch() {
    this.filterText = '';
    this.currentOfficeId = this.roleofficeid;
    this.getClients();
  }

  openDeletePackages(id: number): void {
    this.flagOpenDeletePackage = true;
    this.packageId = id;
  }

  deletePackages(id: number): void {
    this.api.delete('packages/delete', Number(id)).subscribe({
      next: (packages) => {
        this.message = packages.message;
        this.flagDeletedP = true;
        this.flagOpenDeletePackage = false;
        this.flagDeletePackage = false;
        this.getClients();
        this.modalClientClose.close();
      },
      error: (err) => {},
    });

    setTimeout(() => {
      this.flagDeletedP = false;
      this.message = '';
    }, 4000);
  }

  matches(listData: any, term: string) {
    if (listData.email != '' && listData.email != null) {
      return (
        listData.complete.toLowerCase().includes(term.toLowerCase()) ||
        listData.email.toLowerCase().includes(term.toLowerCase()) ||
        listData.phone.includes(term.toLowerCase()) ||
        listData.cp.includes(term.toLowerCase()) ||
        listData.office.name.toLowerCase().includes(term.toLowerCase())
      );
    } else {
      return (
        listData.complete.toLowerCase().includes(term.toLowerCase()) ||
        listData.phone.includes(term.toLowerCase()) ||
        listData.cp.includes(term.toLowerCase()) ||
        listData.office.name.toLowerCase().includes(term.toLowerCase())
      );
    }
  }

  onPageChange(page: number) {

    this.getClients(page);

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { page },
      queryParamsHandling: 'merge'
    });
  }

  //Metodo para visibilizar un máximo de 4 páginas en la paginación
  getVisiblePages(): number[] {
    const max = 4;

    let start = this.page;
    let end = this.page + max - 1;

    if (end > this.totalPages) {
      end = this.totalPages;
      start = end - max + 1;
    }

    if (start < 1) start = 1;

    const pages = [];
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  }

  cancelDeletePackage() {
    this.flagOpenDeletePackage = false;
  }

  filterRecords(): void {
    const filterData = this.clients.filter((data: any) => {
      return this.matches(data, this.filterText);
    });

    this.filterClients = filterData;
  }

  showBirthdaysClients(): void {
    const formattedDate = this.getCurrentDate().split('-');
    this.birthdayClientsInformation(formattedDate[1], '1');

    this.modalClientClose = this.modal.open(this.birthdayClients, { size: 'xl' });
  }

  birthdayClientsInformation(current: String | NgbDateStruct, type: String, finalDate?: String | NgbDateStruct): void {
    const url = (finalDate) ? `clients/birthdays/${type}/${current}/${finalDate}` : `clients/birthdays/${type}/${current}`;

    this.api.get(url).subscribe({
      next: (client) => {
        this.birthdaysData = client.clients;
        this.birthdaysDataFilter = client.clients;
      }
    })
  }

  filterBy(event: any): void {
    const typeFilter = Number(event.target.value);

    if (typeFilter === 1) {
      this.flagDay = false;
      this.flagMonth = false;
      this.flagPerMonth = true;

      const currentDate = this.getCurrentDate().split('-');
      this.birthdayClientsInformation(currentDate[1], String(typeFilter));
    } else if (typeFilter === 2) {
      this.flagDay = true;
      this.flagMonth = false;
      this.flagPerMonth = false;
    } else {
      this.flagDay = false;
      this.flagPerMonth = false;
      this.flagMonth = true;
    }
  }

  private getCurrentDate(): String {
    const currentDate = new Date();
    const formattedDate = [
      currentDate.getFullYear(),
      String(currentDate.getMonth() + 1).padStart(2, '0'),
      String(currentDate.getDate()).padStart(2, '0')
    ].join('-');

    return formattedDate;
  }

  getFiltersByDay(currentDate: NgbDateStruct | null): void {
    if (!currentDate) {
      return;
    }
    //const dayDate = currentDate.month * 100 + currentDate.day;
    console.log(currentDate);
    const dateSelected = `${currentDate.year}-${currentDate.month}-${currentDate.day}`;
    this.birthdayClientsInformation(dateSelected, this.selectedFilter);
  }

  getFiltersByWeek(startDate: NgbDateStruct | null, endDate: NgbDateStruct | null): void {
    if (!startDate || !endDate) {
      return;
    }

    const startDateFormated = `${startDate.year}-${startDate.month}-${startDate.day}`;
    const endDateFormated = `${endDate.year}-${endDate.month}-${endDate.day}`;

    this.birthdayClientsInformation(startDateFormated, this.selectedFilter, endDateFormated);
  }

  filterPerMonth(month: string): void {
    if (!month) {
      return;
    }

    this.birthdayClientsInformation(this.selectedPerMonth, this.selectedFilter);
  }
  
  resetFilter(): void {
    this.selectedFilter = '';
    this.selectedDay = null;
    this.weekStartDate = null;
    this.weekEndDate = null;

    this.flagDay = false;
    this.flagMonth = false;
    this.flagPerMonth = false;

    const currentDate = this.getCurrentDate().split('-');
    this.birthdayClientsInformation(currentDate[1], '1');
  }
}
